module.exports = __webpack_public_path__ + "static/img/hc-w55.0144b09.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/hellocode-v2/hc-w55.svg
// module id = ixVT
// module chunks = 4 119